import { EnvironmentId } from 'api/apiTypes';
import routes from 'api/routes';
import { useSWRConfig } from 'swr';

import { useAxios } from 'utils/transport/useAxios';

import { ScheduledExport } from '../types';

export function useScheduledExportActions() {
  const { post, put, delete: axiosDelete } = useAxios();
  const { mutate } = useSWRConfig();

  // POST /dataexport/schedule
  const create = async (body: ScheduledExport) => {
    const response = await post(routes.dataExport.createSchedule(), body, { withCredentials: true });
    const envGuid = body.environmentGuid;
    if (envGuid) {
      mutate(routes.dataExport.listSchedules(envGuid));
    }
    return response;
  };

  // PUT /dataexport/schedule/:scheduleId
  const update = async (scheduleId: string, body: Partial<ScheduledExport>) => {
    const response = await put(routes.dataExport.updateSchedule(scheduleId), body, {
      withCredentials: true,
    });
    const envGuid = body.environmentGuid;
    if (envGuid) {
      mutate(routes.dataExport.listSchedules(envGuid));
    }
    mutate(routes.dataExport.getSchedule(scheduleId));
    return response;
  };

  // DELETE /dataexport/schedule/:scheduleId
  const deleteAction = async (scheduleId: string, envGuid?: EnvironmentId) => {
    const response = await axiosDelete(routes.dataExport.deleteSchedule(scheduleId), {
      withCredentials: true,
    });
    if (envGuid) {
      mutate(routes.dataExport.listSchedules(envGuid));
    }
    mutate(routes.dataExport.getSchedule(scheduleId));
    return response;
  };

  return {
    create,
    update,
    delete: deleteAction,
  };
}
